<template>
  <v-dialog
    v-model="changelineState.show"
    :eager="true"
    :content-class="dialogContainerclass"
    :overlay-opacity="0.7"
    :overlay-color="'#000000'"
    :persistent="true"
  >
    <div class="dialogHead"><i @click="handleCloseDialog"></i></div>
    <div class="dialogContent">
      <div
        :class="{
          icon: true,
          fail: changelineState.step === STEP.ERROR,
          loading: changelineState.step === STEP.CHECKING,
          success: changelineState.step === STEP.SUCCESS || changelineState.step === STEP.CHECKINGALL
        }"
      ></div>
      <div
        :class="{
          textBox: true,
          checking: changelineState.step === STEP.CHECKING,
          fail: changelineState.step === STEP.ERROR
        }"
      >
        <div class="detailBox">
          <p>{{ getStepText.title }}</p>
          <p v-if="(changelineState.step === STEP.ERROR || changelineState.step === STEP.CHECKINGALL) && ip()">
            {{ ip() }}
          </p>
          <p
            :class="{
              detail: true,
              successed: changelineState.step === STEP.SUCCESS
            }"
          >
            {{ getStepText.detail }}
          </p>
        </div>
      </div>
    </div>

    <div v-show="changelineState.step === STEP.CHECKINGALL" class="domainContainer">
      <div class="domainItem" v-for="(v, i) in domainList" :key="`d${i}`">
        <span>线路{{ i + 1 }}</span>
        <span>{{ getDomainItemInfo(v.ms).ms }}</span>
        <span><i :class="{ icon: true, [getDomainItemInfo(v.ms).iconClass]: true }"></i></span>
        <span
          @click="
            () => {
              handSelectItem(v.domain, v.ms)
            }
          "
        >
          <i
            :class="{
              btn: true,
              [getDomainItemInfo(v.ms).btnClass]: true
            }"
          >
            切换
          </i>
        </span>
      </div>
    </div>
    <div v-show="changelineState.step !== STEP.CHECKING" class="dialogFooter">
      <template v-if="changelineState.step === STEP.SUCCESS">
        <div @click="handleClose">确定</div>
        <div @click="handleCheckingAgain">
          {{ changelineState.mode == 0 ? '重新切换' : '重新诊断' }}
        </div>
      </template>
      <template v-if="changelineState.step === STEP.ERROR">
        <div @click="handleCheckingAgain">再次尝试</div>
      </template>
      <template v-if="changelineState.step === STEP.CHECKINGALL">
        <div @click="handleCheckingAgain">重新诊断</div>
      </template>
    </div>
  </v-dialog>
</template>

<script>
import { originalinstance } from '@api/http'
import axios from 'axios'
import { get as _get } from 'lodash-es'
import jsonp from 'jsonp'
export const STEP = {
  CHECKING: 0, //切换中 （检测一个可用域名再切换）
  SUCCESS: 1,
  ERROR: 2,
  CHECKINGALL: 3 //检测所有域名，展示列表
}

export const ERROR_TIPS = {
  NO_ACCESS: '访问受限[ipxz]',
  NO_AVAILABLE_DOMAIN: '未找到可用的域名节点[abt]',
  NO_CONFIG: '未找到可用的配置[cbt]'
}

export const getCdnsByEnv = siteFlag => {
  let cdnAddress = []
  switch (siteFlag) {
    case 'test':
      cdnAddress = [
      'https://qny.leijun.cx',
      'https://qny.devspire.top',
      'https://qny.sdwkxf.cn',
      'https://aly.kfsjblog.top'
      ]
      break
    case 'rx':
      cdnAddress = [
        'https://qny.hbyd.shop',
        'https://qny.iceplant.vip',
        'https://qny.hzjhzscl.xyz',
        'https://qny.yycm2.site',
        'https://tx.ruanjianshejidasai.xyz'
      ]
      break
    default:
      cdnAddress = [
        'https://qny.leijun.cx',
        'https://qny.devspire.top',
        'https://qny.sdwkxf.cn',
        'https://aly.kfsjblog.top'
      ]
  }

  return cdnAddress
}
export const getTxtPath = (siteFlag, siteCode, file = 'web') => {
  let pathName = ''

  switch (siteFlag) {
    case 'test':
      pathName = 't'
      break
    case 'rx':
      pathName = 'r'
      break
    default:
      pathName = 'z'
      break
  }
  const getTimestamp = new Date().getTime()
  return `/jump/dc/${pathName}/${siteCode}-${file}.txt?t=${getTimestamp}`
}

export const getOneCdn = (cdns, txtPath) => {
  const promiseArr = cdns.map(item => {
    return new Promise((resolve, reject) => {
      axios
        .get(item + txtPath, {
          timeout: 20000
        })
        .then(res => {
          resolve(res.data)
        })
        .catch(err => {
          reject(err)
        })
    })
  })
  return promiseArr
}

export const getValidDomain = (domains, isCheckAll = false) => {
  let oldTime = 0
  return domains.map(item => {
    if (isCheckAll) {
      oldTime = new Date().getTime()
    }
    return new Promise((resolve, reject) => {
      originalinstance
        .post(`${item}/melody/api/v1/base/heartbeat`, null, {
          timeout: 20000
        })
        .then(res => {
          if (res.data.code == '12200') {
            if (isCheckAll) {
              const newTime = new Date().getTime()
              const ms = newTime - oldTime
              resolve({
                ms,
                domain: item
              })
            } else {
              resolve(item)
            }
          } else if (res.data.code == '10008') {
            if (isCheckAll) {
              resolve({
                ms: -403,
                domain: item
              })
            } else {
              resolve('10008')
            }
          }
        })
        .catch(err => {
          if (isCheckAll) {
            reject({
              ms: -1,
              domain: item
            })
          } else {
            reject(err)
          }
        })
    })
  })
}

export const changeDomain = async ({ commit, state }, domainList) => {
  try {
    const domainInfo = await Promise.any(getValidDomain(domainList))

    if (domainInfo == '10008') {
      // jsonp('https://pv.sohu.com/cityjson?ie=utf-8')
      commit(
        'setChangeLineState',
        Object.assign(state.changeLineState, {
          show: true,
          step: STEP.ERROR,
          errorText: ERROR_TIPS.NO_ACCESS
        })
      )
    } else {
      commit(
        'setChangeLineState',
        Object.assign(state.changeLineState, {
          show: true,
          step: STEP.SUCCESS
        })
      )
      const domainCheckMode = _get(state, 'appConfig.app_config.configValue.check_domain_h5_config.mode', null)
      if (domainCheckMode === 1) {
        window.$domain = domainInfo
      } else if (domainCheckMode === 2) {
        window.location.href = `${domainInfo}/#${$app.$route.path}`
      }
    }
  } catch (error) {
    // jsonp('https://pv.sohu.com/cityjson?ie=utf-8')
    commit(
      'setChangeLineState',
      Object.assign(state.changeLineState, {
        show: true,
        step: STEP.ERROR,
        errorText: ERROR_TIPS.NO_AVAILABLE_DOMAIN
      })
    )
  }
}

export default {
  name: 'changeLinedialog',
  computed: {
    STEP() {
      return STEP
    },
    isCheckAllError() {
      if (this.changelineState.step === STEP.CHECKINGALL) {
        const result = this.domainList.filter(item => item.ms !== -1 && item.ms !== -403)
        if (result.length > 0) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    changelineState() {
      return this.$store.state.app.changeLineState
    },
    domainList() {
      return this.$store.state.app.domainList
    },
    dialogContainerclass() {
      if (this.changelineState.step === STEP.CHECKINGALL) {
        return 'dialogContainer checkingAll'
      } else {
        return 'dialogContainer '
      }
    },
    getStepText() {
      const { step, mode, errorText } = this.changelineState
      let text = {
        title: '',
        detail: ''
      }
      switch (step) {
        case STEP.CHECKING:
          if (mode == 0) {
            text = {
              title: '正在进行网络切换',
              detail: '网络切换大约需要一分钟时间，请您耐心等待...'
            }
          } else {
            text = {
              title: '正在进行网络诊断',
              detail: '网络诊断大约需要一分钟时间，请您耐心等待...'
            }
          }
          break
        case STEP.ERROR:
          if (mode == 0) {
            text = {
              title: '网络切换失败',
              detail: errorText
            }
          } else {
            text = {
              title: '网络诊断失败',
              detail: errorText
            }
          }

          break
        case STEP.CHECKINGALL:
          text = {
            title: '网络诊断成功',
            detail: '请选择网络线路'
          }

          break
        case STEP.SUCCESS:
          text = {
            title: '恭喜您',
            detail: '网络切换成功...'
          }

          break
        default:
          break
      }

      return text
    }
  },
  methods: {
    handSelectItem(domain, ms) {
      const info = this.getDomainItemInfo(ms)
      if (!info.isActive) return
      this.$store.dispatch('app/selectDomainItem', domain)
    },
    ip() {
      console.log(window.returnCitySN)
      return window.returnCitySN ? window.returnCitySN.cip : ''
    },
    getDomainItemInfo(ms) {
      let info = {
        ms: '',
        iconClass: '',
        btnClass: '',
        isActive: false
      }
      switch (ms) {
        case -1:
          info = {
            ms: '超时',
            iconClass: 'fail',
            btnClass: 'fail',
            isActive: false
          }
          break
        case -403:
          info = {
            ms: '受限',
            iconClass: 'fail',
            btnClass: 'fail',
            isActive: false
          }
          break

        default:
          if (ms > 1000) {
            info = {
              ms: `${ms}ms`,
              iconClass: 'slow',
              btnClass: '',
              isActive: true
            }
          } else {
            info = {
              ms: `${ms}ms`,
              iconClass: '',
              btnClass: '',
              isActive: true
            }
          }

          break
      }
      return info
    },
    handleClose() {
      this.$store.commit(
        'app/setChangeLineState',
        Object.assign(this.changelineState, {
          show: false
        })
      )
    },
    handleCheckingAgain() {
      this.$store.dispatch('app/getDomain', this.changelineState.mode)
    },
    handleCloseDialog() {
      this.$store.commit(
        'app/setChangeLineState',
        Object.assign(this.changelineState, {
          show: false
        })
      )
    }
  }
}
</script>

<style lang="scss">
@keyframes failLoading {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.dialogContainer {
  overflow: hidden;
  background-color: #eee;
  margin: 0;
  width: 226px;
  box-shadow: none;

  &.checkingAll {
    width: 320px;

    .domainContainer {
      margin-bottom: 10px;
      //max-height: 51px;
      max-height: 231px;
      overflow-y: auto;

      &::-webkit-scrollbar-track-piece {
        // background-color: rgba(0, 0, 0, 0);
        // border-left: 1px solid rgba(0, 0, 0, 0);
      }

      &::-webkit-scrollbar {
        background-color: #cfd5da;
        width: 4px;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #a8b2be;
        background-clip: padding-box;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
        min-height: 18px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: #a8b2be;
        -webkit-border-radius: 4px;
        -moz-border-radius: 4px;
        border-radius: 4px;
      }

      .domainItem {
        display: flex;
        // padding: 0 20px;
        justify-content: space-between;
        margin-bottom: 12px;

        span {
          color: #6f6f6f;
          width: 25%;
          //   text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;

          .icon {
            display: flex;
            width: 18px;
            height: 18px;
            background-image: url('../assets/base64Img/goodNet.png');
            background-size: contain;

            &.fail {
              background-image: url('../assets/base64Img/noNet.png');
            }

            &.slow {
              background-image: url('../assets/base64Img/badNet.png');
            }
          }

          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 18px;
            border-radius: 9px;
            color: #fff;
            background-color: #232323;
            font-style: initial;

            &.fail {
              opacity: 0.5;
            }
          }
        }
      }
    }
  }

  .dialogHead {
    display: flex;
    position: relative;
    height: 30px;

    i {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      width: 12px;
      height: 12px;
      margin: 9px;
      //   margin-top: 10px;
      background-image: url('../assets/base64Img/close.png');
      background-size: contain;
    }
  }

  .dialogContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .icon {
      width: 70px;
      height: 70px;
      border: none;
      background-color: #eee !important;
      background-size: contain;

      &.success {
        background-image: url('../assets/base64Img/success.png');
      }

      &.fail {
        background-image: url('../assets/base64Img/error.png');
      }

      &.loading {
        background-image: url('../assets/base64Img/loading.png');
        animation: failLoading 2s linear infinite;
      }
    }

    .textBox {
      margin-bottom: 20px;
      margin-top: 30px;

      &.checking {
        margin-bottom: 62px;
      }

      &.fail {
        margin-bottom: 10px;
        margin-top: 15px;
      }

      p {
        text-align: center;
        font-size: 14px;
        color: #3b3b3b;
        margin-bottom: 0;
        height: 20px;
        line-height: 20px;
        margin-top: 5px;

        &:first-child {
          margin-top: 0;
        }

        &.detail {
          color: #767676;
          font-size: 12px;
          max-width: 180px;

          &.successed {
            font-size: 14px;
            color: #3b3b3b;
          }
        }
      }
    }
  }

  .dialogFooter {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 0px;
    margin-bottom: 20px;
    font-size: 12px;

    div {
      background-color: #81c35d;
      height: 22px;
      line-height: 22px;
      width: 70px;
      border-radius: 10px;
      text-align: center;
      color: #fff;
      margin: 0 10px;
    }
  }
}
</style>
